export const dialogHelpers = {
  methods: {
    setDialogError(message) {
      this.setDialogMessage(message, 'danger');
    },
    setDialogSuccess(message) {
      this.setDialogMessage(message, 'success');
    },
    setDialogMessage(message, variant) {
      this.$store.dispatch('notifications/setDialogMessage', { message, variant });
    },
    clearDialogMessage() {
      this.$store.dispatch('notifications/clearDialogMessage');
    },
    confirmDeleteDialog(name) {
      return this.$bvModal
        .msgBoxConfirm(this.$t('common.confirm_delete', { name }), {
          title: this.$t('common.confirm_action'),
          okVariant: "danger",
          okTitle: this.$t('common.confirm'),
          cancelTitle: this.$t('common.cancel'),
        })
    },
    
    confirmDialog(confirm, title = this.$t('common.confirm_action')) {
      return this.$bvModal
        .msgBoxConfirm(confirm, {
          title: title,
          okVariant: "success",
          okTitle: this.$t('common.confirm'),
          cancelTitle: this.$t('common.cancel'),
        })
    },
  }
};